import { render, staticRenderFns } from "./std-vip-dialog.vue?vue&type=template&id=30c9d124"
import script from "./std-vip-dialog.vue?vue&type=script&lang=js"
export * from "./std-vip-dialog.vue?vue&type=script&lang=js"
import style0 from "./std-vip-dialog.vue?vue&type=style&index=0&id=30c9d124&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports